module.exports = "/images/family_white.png?ad9cf5469c47bc5adc1d9b902ef640c6";